import React from "react";
import { Breadcrumbs, P } from "../../AbstractElements";
import { Page, SampleCard, SamplePage } from "../../Constant";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../Common/CommonCardHeader";
import { SAMPLE_DATA } from "../../Data/Pages";

const SamplePageContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={SamplePage} parent={Page} title={SamplePage} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SampleCard} span={SAMPLE_DATA} />
              <CardBody>
                <P>While written content continues to reign supreme as the cornerstone of every brand's digital marketing strategy, video and image-based content are becoming more and more prominent in the world of content marketing. The regular blog, social media posts, and a wide range of other written content formats are just a few examples.</P>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SamplePageContainer;
